import React, { useEffect, useState } from "react";
import "./style.css";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";

import Select from "react-select";
import { canvas_designs } from "../../utils/designsTypes";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const customStyles = {
  control: (base) => ({
    ...base,
    height: 45,
    minHeight: 45,
    width: 300,
  }),
};

function CreativeCreateDesign() {
  const [open, setOpen] = useState(false);
  const [design, setDesign] = useState(0);
  const [canvaDesign, setCanvaDesign] = useState("");
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const makeDesign = (e) => {
    e.preventDefault();
    let token = localStorage.getItem("skiUserToken");
    window.location.href = `https://ski-editor.vercel.app?create=${canvaDesign.value}&AUTH_TOKEN=${token}`;
  };

  useEffect(() => {
    document.title = "Create a Design | Ski Design";
    handleClickOpen();
  }, []);
  return (
    <div>
      <Dialog
        open={open}
        maxWidth={"md"} // 'sm' || 'md' || 'lg' || 'xl'
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="creative-design-container form-container">
          <div className="upper-rotated-container"></div>
          <div
            style={{ top: "55%" }}
            className="creative-design-cont form-cont position-relative"
          >
            <h2 className="form-header">Create a Design</h2>
            <p className="under-header mb-3">
              Tell us, what you want Ski to design
            </p>
            <form className="d-flex flex-column align-items-center justify-content-center">
              <Select
                options={canvas_designs}
                onChange={(newValue) => setCanvaDesign(newValue)}
                className="text-xs mt-8"
                styles={customStyles}
              />
              <select
                name="what-to-design"
                className="what-to-design"
                id="#"
                defaultValue="0"
                value={design}
                onChange={(e) => setDesign(e.target.value)}
              >
                <option value="0" disabled>
                  Choose Category
                </option>
                <option value="grocery">Grocery</option>
                <option value="restaurants">Restaurants</option>
                <option value="delivery">Delivery services</option>
                <option value="cleaning">Cleaning services</option>
                <option value="training">Personal Training and Fitness</option>
                <option value="irrigation">Irrigation Services</option>
              </select>
              <button
                onClick={makeDesign}
                className="position-relative my-3 create-design-btn submit-btn"
              >
                Start
              </button>
            </form>
          </div>
          <div className="creative-de-lower-rotated lower-rotated-container"></div>
        </div>
      </Dialog>
    </div>
  );
}

export default CreativeCreateDesign;
